import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowRight, faFile, faListCheck, faPhone, faQuestion, faUserPlus,
} from '@fortawesome/pro-regular-svg-icons';
import { Button } from 'components/ui/button';

import { useConversationContext } from '../conversation_context';

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

// TODO: Replace with dynamic starters
const STARTERS = [
  {
    icon: faListCheck,
    label: "What's next?",
    sub: 'Walk my whole day, top move first',
    prompt: 'What should I do today?',
  },
  {
    icon: faPhone,
    label: 'Build call list',
    sub: 'Rank warmest prospects to call now',
    prompt: 'Build a call list of my warmest prospects',
  },
  {
    icon: faUserPlus,
    label: 'Add a contact',
    sub: 'Add someone new to my book',
    prompt: 'Add a contact',
  },
  {
    icon: faFile,
    label: 'Generate a doc',
    sub: 'Client reports, marketing packages',
    prompt: 'Help me generate a document',
  },
  {
    icon: faQuestion,
    label: 'What can you do?',
    sub: 'See everything I can help with',
    prompt: 'What can you do?',
  },
];

function greeting(firstName?: string | null): string {
  const hour = new Date().getHours();
  const partOfDay = hour < 12 ? 'Morning' : hour < 17 ? 'Afternoon' : 'Evening';
  return firstName ? `${partOfDay}, ${firstName}.` : `${partOfDay}.`;
}

function StarterIcon({ icon }: { icon: IconDefinition }) {
  return (
    <span
      className={'ai-assistant-starter-icon bg-gradient-ai-decorative d-inline-flex align-items-center'
        + ' justify-content-center rounded-circle flex-shrink-0'}
    >
      <FontAwesomeIcon className="icon-gradient-ai" icon={icon} />
    </span>
  );
}

interface Props {
  onSelect: (prompt: string) => void;
}

export default function ConversationStarters({ onSelect }: Props) {
  const { firstName, hasResumableChat, resumePreviousChat } = useConversationContext();

  return (
    <div className="d-flex flex-column gap-5 mt-auto pb-3">
      {hasResumableChat && (
        <div>
          <Button
            className="text-primary fw-semibold px-0"
            iconEnd={faArrowRight}
            label="Resume chatting"
            size="sm"
            variant="ghost"
            onClick={resumePreviousChat}
          />
        </div>
      )}

      <h5 className="text-gradient-ai fw-semibold mb-0">
        {greeting(firstName)}
        <br />
        How can I help?
      </h5>

      <div className="d-flex flex-column">
        {STARTERS.map(starter => (
          <Button
            className={'bg-gradient-ai-card-hover border-hover-purple-heart-300 d-flex align-items-center'
              + ' gap-3 p-2 text-start text-body'}
            key={starter.label}
            variant="ghost"
            onClick={() => onSelect(starter.prompt)}
          >
            <StarterIcon icon={starter.icon} />
            <span className="d-flex flex-column flex-grow-1 overflow-hidden lh-sm">
              <span className="fw-semibold">{starter.label}</span>
              <span className="text-muted small text-truncate">{starter.sub}</span>
            </span>
          </Button>
        ))}
      </div>
    </div>
  );
}
